import React, {useEffect, useRef, useState} from "react";
import Styles from "./styles/pr.module.css"
import Slide1 from "./images/slide_1_faith-1.jpg";
import Slide2 from "./images/slide_2_joining_resources-1.jpg";
import Slide3 from "./images/slide_3_increasing_ministry_effectiveness-1.jpg";
import Slide4 from "./images/slide_4_support_and_encouragement-1.jpg";
import Slide5 from "./images/slide_5_logo.jpg";

const Slideshow = (props) => {
    const [slideIndexState, setSlideIndexState] = useState(1);
    const slideIndex = useRef(1);

    useEffect(() => {
        showDivs();
        const timer = setInterval(() => {
            plusDivs(1);
        }, 10000);

        return () => clearInterval(timer);
    }, []);

    const plusDivs = (n) => {
        let newIndex = slideIndex.current + n;
        let imageCount = document.getElementsByClassName('slide_image').length;
        if(newIndex > imageCount) {
            newIndex = 1;
        } else if (newIndex < 1) {
            newIndex = imageCount;
        }
        slideIndex.current = newIndex;
        setSlideIndexState(newIndex);
        showDivs();
    }
    function currentDiv(n) {
        slideIndex.current = n;
        setSlideIndexState(n);
        showDivs();
    }

    function showDivs() {
        var i;
        var x = document.getElementsByClassName('slide_image');
        var dots = document.getElementsByClassName(Styles.pr_slideshow_button);
        for (i = 0; i < x.length; i++) {
            x[i].style.display = "none";
        }
        x[slideIndex.current - 1].style.display = "block";
    }
    const SlideshowButton = (props) => {
        if(props.selected == props.index) {
            return (
                <span
                    className={`${Styles.pr_slideshow_button} ${Styles.pr_slideshow_button_selected}`}
                    onClick={() => currentDiv(props.index)} title={props.selected} />
            )
        } else {
            return (
                <span
                    className={Styles.pr_slideshow_button}
                    onClick={() => currentDiv(props.index)} title={props.selected} />
            )
        }
    }

    return (
        <div className={Styles.pr_slideshow_holder}>
            <img
                alt="Faith Expressing Itself in Love"
                className={`${Styles.pr_slideshow_image} slide_image`}
                src={Slide1}
            />
            <img
                alt="Joining Resources"
                className={`${Styles.pr_slideshow_image} 
                slide_image`}
                src={Slide2}
            />
            <img
                alt="Increasing Ministry Effectiveness"
                className={`${Styles.pr_slideshow_image} slide_image`}
                src={Slide3}
            />
            <img
                alt="Support and Encouragement"
                className={`${Styles.pr_slideshow_image} slide_image`}
                src={Slide4}
            />
            <img
                alt="Heartland Association of Churches"
                className={`${Styles.pr_slideshow_image} slide_image`}
                src={Slide5}
            />
            <div className={props.hide_controls ? Styles.pr_hide : Styles.pr_slideshow_controls}>
                <div className={Styles.pr_slideshow_left} onClick={() => plusDivs(-1)}>&#10094;</div>
                <div className={Styles.pr_slideshow_right} onClick={() => plusDivs(1)}>&#10095;</div>
                {[1,2,3,4].map(item => (
                    <SlideshowButton selected={slideIndexState} index={item} key={item} />
                ))}
            </div>
        </div>
    )
}
export default Slideshow;